import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { useTheme } from '@material-ui/core/styles';

interface CriteriumSkeletonProps {
  variant?: 'text' | 'rect' | 'circle',
  width?: string,
  style?: any
}

export default function CriteriumSkeleton ({
  variant = 'text',
  width = '100%',
  style = {}
}: CriteriumSkeletonProps) {
  const theme = useTheme();
  return (
    <Skeleton
      variant={variant}
      animation={false}
      width={width}
      style={{
        borderRadius: theme.shape.borderRadius * 4,
        ...style
      }}
    />
  );
}
